import { Brand } from '../redux/types/products'

/**
 * Given a brand this will return the name decorated with the lock emoji if that brand has been locked by the catalog team.
 */
export const displayBrandAndStatus = (brand: Pick<Brand, 'catalog_status' | 'name'>) => {
  if (brand.catalog_status === 'locked') {
    return `${brand.name} 🔒`
  } else {
    return brand.name
  }
}
